<template>
    <div class="multi-select">
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <!--      <multiselect v-model="value" :options="options"></multiselect>-->
            <multiselect
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                tag-placeholder="field.placeholder"
                :placeholder="field.placeholder"
                label="title"
                track-by="title"
                :options="field.options"
                :multiple="true"
                :data-vv-name="field.label"
                :taggable="true"
                :disabled="loading || isDisable"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
                @input="setModelValue"
            ></multiselect>
            <!--      Hell-->
            <!--      {{ field.value }}-->
        </b-form-group>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import request from '@/utils/request'
import { mapGetters } from 'vuex'

export default {
    /*
   |--------------------------------------------------------------------------
   | Component > inject
   |--------------------------------------------------------------------------
   */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    components: {
        Multiselect,
        // IdentityType,
        // IdentityDocument,
        // UtilityBill,
        // Cropper,
        // OtherNationalities,
        // Signature,
        // Disclaimer,
        // VueCroppie,
    }, // End of Component > components

    props: {
        field: { type: Object },
    },
    data() {
        return {
            model: [],
            options: [],
            isDisable: true,
        }
    },
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    },
    created() {
        if (this.field.key == 'basicInfo.otherNationalities') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .hasOtherNationalities // could also put a Getter here
                },
                (newValue) => {
                    if (newValue == 'No') {
                        this.isDisable = true
                        this.field.isRequired = false
                        this.model = ''
                        this.setModelValue()
                    } else {
                        this.isDisable = false
                        this.field.isRequired = true
                    }
                },
                //Optional Deep if you need it
                {
                    deep: true,
                }
            )
        }
    },
    async mounted() {
        // this.model = this.value;
        // //console.log("Other Nationality Component");
        // //console.log("Options", this.options);
        await this.getRecords()
        this.getModelValue()

        if (this.field.key == 'basicInfo.otherNationalities') {
            if (
                this.$store.state.registration.form.basicInfo
                    .hasOtherNationalities == 'Yes'
            ) {
                this.isDisable = false
                this.field.isRequired = true
                // this.model = ''
                // this.setModelValue()
            }
        }
    },
    methods: {
        getModelValue() {
            if (this.field.isLocked) {
                this.model = this.$store.getters.getField(this.field.key)
            } else {
                let customInfo = this.$store.getters.getField(`customInfo`)
                this.model = customInfo[this.field._id]
                    ? customInfo[this.field._id].value
                    : null
            }
        },
        /**
         * get the dropdown values when required
         *
         * @return {void}
         */
        setModelValue() {
            // //console.log("tag")
            // //console.log(this.model)
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: this.model,
                })
            } else {
                this.$store.commit('updateField', {
                    key: `customInfo.${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: this.model,
                    },
                })
            }
            // //console.log("Value",  this.$store.state.registration.form.basicInfo.otherNationalities)
        },
        async getRecords() {
            try {
                // fetch the list of associated configurations
                let { data } = await request({
                    url: `/configurations/${this.field.association}`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })

                // update the local list of options
                this.field.options = data.data

                // //console.log("Countries " , this.field.options)
                // if (this.field.type === 'isd-code') {
                //   this.options = this.options.filter((item) => {
                //     item.isdCodeTitle = `${item.title} (${item.isdCode})`
                //     return item
                //   })
                // }
            } catch (error) {
                //console.log(error)
            }
        }, // End of getRecords() method
    },
    /*
   |--------------------------------------------------------------------------
   | Component > computed
   |--------------------------------------------------------------------------
   */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading', 'form']),
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
}
</script>
